// extracted by mini-css-extract-plugin
module.exports = {"root":"PdpHeader_root__H1Hm8","breadcrumbs":"PdpHeader_breadcrumbs__t_JDu"};